import { Component, input } from '@angular/core';

@Component({
  selector: 'app-mode-card',
  imports: [],
  templateUrl: './mode-card.html',
  styleUrl: './mode-card.scss',
})
export class ModeCard {
  readonly icon = input.required<string>();
  readonly label = input.required<string>();
  readonly subtitle = input<string>();
  readonly variant = input<'primary' | 'secondary'>('primary');
}
